export interface SortOption {
  value: string;
  label: string;
}

export const SORT_OPTIONS: SortOption[] = [
  { value: 'BestSeller', label: 'Best selling' },
  { value: 'Latest', label: 'Latest' },
  { value: 'PriceLowToHigh', label: 'Price: low to high' },
  { value: 'PriceHighToLow', label: 'Price: high to low' },
];

export const DEFAULT_SORT_VALUE = 'BestSeller';

export const DEFAULT_PAGE = 1;
